"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get decryptPropIfRequired () {
        return decryptPropIfRequired;
    },
    get encryptPropIfRequired () {
        return encryptPropIfRequired;
    },
    get getCredentialEncryptSecret () {
        return getCredentialEncryptSecret;
    },
    get isEncryptionRequired () {
        return isEncryptionRequired;
    }
});
const _cryptojs = /*#__PURE__*/ _interop_require_default(require("crypto-js"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const getCredentialEncryptSecret = ()=>process.env.NC_CONNECTION_ENCRYPT_KEY;
const isEncryptionRequired = (secret = getCredentialEncryptSecret())=>{
    return !!secret;
};
const encryptPropIfRequired = ({ data, prop = 'config', secret = getCredentialEncryptSecret() })=>{
    if (!data || data[prop] === null || data[prop] === undefined) {
        return;
    }
    const val = typeof data[prop] === 'string' ? data[prop] : JSON.stringify(data[prop]);
    if (!secret) {
        return val;
    }
    return _cryptojs.default.AES.encrypt(val, secret).toString();
};
const decryptPropIfRequired = ({ data, prop = 'config', secret = getCredentialEncryptSecret() })=>{
    if (!data || data[prop] === null || data[prop] === undefined) {
        return;
    }
    let jsonString = data[prop];
    if (secret) {
        try {
            jsonString = _cryptojs.default.AES.decrypt(data[prop], secret).toString(_cryptojs.default.enc.Utf8);
        } catch (unused) {
            throw new Error('Config decryption failed');
        }
    }
    return typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
};
